import React, { ComponentProps } from 'react';
import ReactDOM from 'react-dom/client';
import { Button, ButtonProps } from '../input/Button';
import { Box } from '../layout/Box';
import { Typography } from '../typography/Typography';
import { Dialog, DialogActions, DialogContent } from './Dialog';

type IAction = Omit<ButtonProps, 'children'> & {
    label: string;
};

interface AlertProps extends ComponentProps<typeof Box> {
    title: string;
    description: string;
    actions: IAction[];
}

export class AlertRejectedError extends Error {
    constructor(message: string = 'Действие отменено') {
        super(message);
        this.name = 'AlertRejectedError';
    }
}

export const Alert = (props: AlertProps) => {
    const { title, description, actions, ...other } = props;

    return (
        <Dialog {...other}>
            <DialogContent>
                <Typography variant="title3" weight="bold" mb={2}>
                    {title}
                </Typography>
                <Typography variant="body">{description}</Typography>
            </DialogContent>
            <DialogActions>
                {actions.map(({ label, ...other }: IAction, index) => (
                    <Button size="l" key={index} flexGrow={1} variant="outlined" {...other}>
                        {label}
                    </Button>
                ))}
            </DialogActions>
        </Dialog>
    );
};

export const confirmAlert = (
    title: string,
    description: string,
    cancelText: string = 'Отмена',
    confirmText: string = 'Подтвердить',
): Promise<void> =>
    new Promise((resolve, reject) => {
        const container = document.createElement('div');

        container.style.setProperty('zIndex', '999');
        document.body.appendChild(container);

        const root = ReactDOM.createRoot(container);

        root.render(
            <Alert
                height="auto"
                borderRadius={3}
                title={title}
                description={description}
                actions={[
                    {
                        label: cancelText,
                        variant: 'filled',
                        color: 'secondary',
                        onClick: () => {
                            root.unmount();
                            reject(new AlertRejectedError());
                        },
                    },
                    {
                        label: confirmText,
                        variant: 'filled',
                        color: 'primary',
                        onClick: () => {
                            root.unmount();
                            resolve();
                        },
                    },
                ]}
            />,
        );
    });
